const Form098StepSequence = {
    applicantWithD: [
        "Statement",
        "BasicInfo",
        "PartA",
        "PartB",
        "PartC",
        "PartD",
        "PartE",
        // "PartF",
        "Confirmation",
    ],
    applicantWithoutD: [
        "Statement",
        "BasicInfo",
        "PartA",
        "PartB",
        "PartC",
        "PartE",
        // "PartF",
        "Confirmation",
    ],
    applicantReturn: [
        "BasicInfo",
        "PartA",
        "PartB",
        "PartC",
        "PartD",
        "PartE",
        // "PartF",
        "Confirmation",
    ],
    firstApproverStep: ["BasicInfo", "PartA", "PartB", "PartC", "Confirmation"],
    edbWithD: [
        "BasicInfo",
        "PartA",
        "PartB",
        "PartC",
        "PartD",
        "PartE",
        // "PartF",
        "Confirmation",
    ],
    edbWithoutD: [
        "BasicInfo",
        "PartA",
        "PartB",
        "PartC",
        "PartE",
        // "PartF",
        "Confirmation",
    ],
    secondApplicantStep: ["PartG", "Confirmation"],
    finalApproverStep: ["PartG", "Confirmation"],
};

export default Form098StepSequence;
